export class Carousel {
  id?: number;
  image: string;
  cssStyle: string;
  orderNumber: number;
  cloudTitleEn?: string;
  cloudTitleRu?: string;
  cloudDescriptionEn?: string;
  cloudDescriptionRu?: string;
  cloudCssStyle?: string;
  file?: File;
  toDelete?: boolean = false;
  version: number = 0;
  constructor(data?: Carousel) {
      this.image = data?.image ?? '';
      this.cssStyle = data?.cssStyle ?? '';
      this.orderNumber = data?.orderNumber ?? 0;
      this.cloudTitleEn = data?.cloudTitleEn ?? '';
      this.cloudTitleRu = data?.cloudTitleRu ?? '';
      this.cloudDescriptionEn = data?.cloudDescriptionEn ?? '';
      this.cloudDescriptionRu = data?.cloudDescriptionRu ?? '';
      this.cloudCssStyle = data?.cloudCssStyle ?? '';
      this.file = data?.file;
      this.toDelete = data?.toDelete;
      this.version = data?.version ?? 0;
  }
}
